import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import B2BTheme, { EPRTheme } from '@thd-olt-global/b2b-theme';
import { whyDidYouRender } from '../wdyr.jsx';
import { App } from './App';
import { getRoutes, getServerPages } from './routes.js';

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());

  const serverPages = await getServerPages();

  if (client.serverData.themeName === 'epr') {
    client.setTheme({ name: 'epr', template: EPRTheme });
  } else if (client.serverData.themeName === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }
  const customerType =
    client.customer.type || window.THDCustomer?.default.customerType || '';
  const customerRole =
    client.customer.role || window.THDCustomer?.default.role || '';
  const userId =
    client.customer.userId || window.THDCustomer?.default.userID || '';
  const svocId =
    client.customer.svocId || window.THDCustomer?.default.svocID || '';

  client.render(
    <App
      customerType={customerType.toUpperCase()}
      customerRole={customerRole.toUpperCase()}
      userId={userId}
      svocId={svocId}
      serverPages={serverPages}
    />,
  );
});
